import React from "react";
import '../styles/GalleryI.css';

function GalleryI() {

    return (
        <div className="container-fluid py-2 my-5-5 gallery-1-section-background">
            <div className="container-fluid gallery-1-background" />
            <div className="container">
                <img src={require('../assets/photos/DSC04990-Poprawione-Szum.webp')} className="gallery-photo-wide img-hover-zoom rounded img-shadow" />
                <div className="row my-5-5">
                    <div className="col-12 col-md-6 text-white gallery-paragraph-1-text-container">
                        <h4 className="fs-2">Wystrój wnętrza</h4>
                        <hr className="divider" />
                        <p>Poznaj wyjątkowy klimat naszej restauracji, który tworzą ciepłe wnętrza
                        i eleganckie detale.</p>
                    </div>
                    <div className="col-12 col-md-6 gallery-paragraph-1-photo-container">
                        <img src={require('../assets/photos/DSC08797.webp')} className="gallery-photo-paragraph img-hover-zoom rounded img-shadow" />
                    </div>
                </div>
                <div className="row my-5-5 gallery-set-type-1">
                    <div className="col-12 col-md-4 photo-justify-start">
                        <img src={require('../assets/photos/opening-hours.webp')} className="rounded img-hover-zoom gallery-set-photo-1 img-shadow" />
                    </div>
                    <div className="col-12 col-md-8 photo-justify-end">
                        <img src={require('../assets/photos/DSC04989-Poprawione-Szum.webp')} className="rounded img-hover-zoom gallery-set-photo-2 mt-photo img-shadow" />
                    </div>
                </div>
                <div className="row my-5-5 gallery-set-type-2">
                    <div className="col-12 col-md-8 photo-justify-start">
                        <img src={require('../assets/photos/DSC02471-Poprawione-Szum-2.webp')} className="rounded img-hover-zoom gallery-set-photo-2 img-shadow" />
                    </div>
                    <div className="col-12 col-md-4 photo-justify-end">
                        <img src={require('../assets/photos/DSC02586-Poprawione-Szum.webp')} className="rounded img-hover-zoom gallery-set-photo-1 mt-photo img-shadow" />
                    </div>
                </div>
                <div className="row">
                <div className="col-12 col-md-6 gallery-paragraph-2-photo-container">
                        <img src={require('../assets/photos/DSC08782.webp')} className="gallery-photo-paragraph img-hover-zoom rounded img-shadow" />
                    </div>
                    <div className="col-12 col-md-6 gallery-paragraph-2-text-container">
                        <h4 className="fs-2">Wydarzenia i spotkania</h4>
                        <hr className="divider" />
                        <p>Odkryj, jak wyglądały nasze niezapomniane imprezy okolicznościowe
                        i spotkania w gronie przyjaciół oraz rodziny.</p>
                    </div>
                </div>
                <div className="row my-5-5 gallery-set-type-1">
                    <div className="col-12 col-md-4 photo-justify-start">
                        <img src={require('../assets/photos/DSC00375-Poprawione-Szum.webp')} className="rounded img-hover-zoom gallery-set-photo-1 img-shadow" />
                    </div>
                    <div className="col-12 col-md-8 photo-justify-end">
                        <img src={require('../assets/photos/DSC08797.webp')} className="rounded img-hover-zoom gallery-set-photo-2 mt-photo img-shadow" />
                    </div>
                </div>
                <div className="row my-5-5 gallery-set-type-2">
                    <div className="col-12 col-md-8 photo-justify-start">
                        <img src={require('../assets/photos/DSC00470-Poprawione-Szum.webp')} className="rounded img-hover-zoom gallery-set-photo-2" />
                    </div>
                    <div className="col-12 col-md-4 photo-justify-end">
                        <img src={require('../assets/photos/DSC02506.webp')} className="rounded img-hover-zoom gallery-set-photo-1 mt-photo" />
                    </div>
                </div>
            </div>
        </div>
    )

}

export default GalleryI;